import { createContext } from 'react';
import type { ReportError } from '@peloton/error-reporting';

export const ERROR_REPORTER_FALLBACK = () => null;
export const ReportErrorContext = createContext<ReportError>(ERROR_REPORTER_FALLBACK);
